import React from "react";
import "./App.css";
import MainLayout from "./Layouts/MainLayout";
import $ from "jquery";
import nh100Logo from "./assets/images/nh100-logo.png";
import fre8wiseLogo from "./assets/images/fre8wise-logo.png";
import ioclLogo from "./assets/images/iocl-logo.png";
import hpeLogo from "./assets/images/hpe-logo.png";
import flyyLogo from "./assets/images/flyy-logo.png";
import revvLogo from "./assets/images/revv-logo.png";
import greenDrive from "./assets/images/greendrive_logo.svg";
import moment from "moment";
import { dateFormat } from "./constants/constants";
// import mixpanel from "mixpanel-browser";
import Biliti_Primary_Logo from './assets/images/Biliti_Primary_Logo.svg'
import mondayLogo from './assets/images/monday.svg'
import ketoLogo from './assets/images/keto_logo.png'
import gozapLogo from './assets/images/gozap.svg'
import jupiterLogo from './assets/images/jupiterLogo.png'
import cruzex from './assets/images/cruzex.png'

window.vehicleLoadedProgress = {
  totalVehicles: 0,
  loadedVehicles: 0,
  progress: 0,
};
window.vehicleLoadedProgressListeners = {};
window.addVehicleLoadedProgressListener = (key, fn) => {
  window.vehicleLoadedProgressListeners[key] = fn;
};
window.updateVehicleLoadedProgress = (progress) => {
  try {
    window.vehicleLoadedProgress = progress;
    for (let idx in window.vehicleLoadedProgressListeners) {
      if (window.vehicleLoadedProgressListeners[idx]) {
        window.vehicleLoadedProgressListeners[idx](
          window.vehicleLoadedProgress
        );
      }
    }
  } catch (error) {
    console.error("Error updating vehicle progress:", error);
  }
};

window.graphListeners = {
  zoom: [],
  dragZoom: [],
  dragZoomData: [],
  brush: [],
  mouseover: [],
  graphBroadcast: [],
};

window.clearGraphListener = () => {
  window.graphListeners = {
    zoom: [],
    brush: [],
    dragZoom: [],
    mouseover: [],
    graphBroadcast: [],
  };
};

window.addGraphListener = (key, listener) => {
  if (key in window.graphListeners) {
    window.graphListeners[key].push(listener);
  }
};

window.callGraphListeners = (key, msg) => {
  if (key in window.graphListeners) {
    for (let idx in window.graphListeners[key]) {
      window.graphListeners[key][idx](msg);
    }
  }
};

window.escapeListeners = {};
window.onEscape = (uid, listener) => {
  if (!(uid in window.escapeListeners)) {
    window.escapeListeners[uid] = listener;
  }
};

window.addEventListener("keydown", (e) => {
  if (e.keyCode === 27) {
    for (let idx of Object.keys(window.escapeListeners).reverse()) {
      let rslt = window.escapeListeners[idx](e);
      if (rslt === false) break;
    }
    document.activeElement.blur();
  }
});

window.onSaveVehicleStateListeners = {};
window.addOnSaveVehicleStateListener = (key, method) => {
  if (!(key in window.onSaveVehicleStateListeners)) {
    window.onSaveVehicleStateListeners[key] = method;
  }
};

window.saveVehicleState = (data) => {
  window.refreshGraphs();
  setTimeout(() => {
    window.selectedVehicles = data;
    window.selectedVehiclesUpdatedAt = Date.now();
    for (let idx in window.onSaveVehicleStateListeners) {
      window.onSaveVehicleStateListeners[idx](data);
    }
  }, 101);
};

window.vehicleListeners = {};
window.addVehicleListener = (key, method) => {
  if (!(key in window.vehicleListeners)) {
    window.vehicleListeners[key] = method;
  }
};
window.vehicleUpdated = (data) => {
  window.selectedVehicle = data;
  for (let idx in window.vehicleListeners) {
    window.vehicleListeners[idx](data);
  }
};

window.markerRightClickListener = {};
window.showInGoogleMaps = (lat, lng) => {
  window.open(
    "https://www.google.com/maps/search/?api=1&query=" + lat + "," + lng,
    "_blank"
  );
};

window.addMarkerRightClickListener = (key, listener) => {
  if (!(key in window.markerRightClickListener)) {
    window.markerRightClickListener[key] = listener;
  }
};

window.callMarkerRightClickListener = (params) => {
  for (let idx in window.markerRightClickListener) {
    window.markerRightClickListener[idx](params);
  }
};

window.freezMap = { active: false };

window.dependenciesListeners = {};
window.addDependenciesLoadedListener = (key, listener) => {
  window.dependenciesListeners[key] = listener;
};
window.allDependenciesLoaded = () => {
  for (let idx in window.dependenciesListeners) {
    window.dependenciesListeners[idx]();
  }
};

window.isWhiteLabelAvailable = (str) => {
  return window.location.href.indexOf(str) !== -1;
};

/*
 *
 *   InGraph2
 *
 * */

window.InGraph2Listeners = {};

window.addInGraph2Listener = (
  eventName = null,
  key = null,
  listener = null,
  graphSetName = "default"
) => {
  if (!eventName || !key || !listener) {
    console.error("[InGraph2] Adding Listener Failed");
    return;
  }

  if (!(graphSetName in window.InGraph2Listeners)) {
    window.InGraph2Listeners[graphSetName] = {};
  }
  if (!(eventName in window.InGraph2Listeners[graphSetName])) {
    window.InGraph2Listeners[graphSetName][eventName] = {};
  }
  window.InGraph2Listeners[graphSetName][eventName][key] = listener;
};

window.callInGraph2Listeners = (eventName = null, params, graphSetName) => {
  if (!graphSetName) graphSetName = "default";

  if (!eventName) {
    console.error("[InGraph2] Invalid Event, No Event Name");
    return;
  }

  if (window.InGraph2Listeners[graphSetName]) {
    for (let idx in window.InGraph2Listeners[graphSetName][eventName]) {
      window.InGraph2Listeners[graphSetName][eventName][idx](params);
    }
  }
};

window.setSelectedGraph = (uid) => {
  window.selectedGraphUID = uid;
};

window.getSelectedGraph = () => {
  return window.selectedGraphUID;
};

window.mapEventListeners = {};
window.addMapEventListener = (uid, eventName, listener) => {
  if (!(eventName in window.mapEventListeners)) {
    window.mapEventListeners[eventName] = {};
  }
  window.mapEventListeners[eventName][uid] = listener;
};
window.triggerMapEvent = (eventName, params) => {
  if (!window.mapEventListeners[eventName]) return;
  for (let uid in window.mapEventListeners[eventName]) {
    window.mapEventListeners[eventName][uid](params);
  }
};

const alarmTypes = [
  { key: "Harsh Acceleration", keywords: ["cceleration"] },
  { key: "Harsh Braking", keywords: ["raking"] },
  { key: "Harsh Left Turn", keywords: ["left"] },
  { key: "Harsh Right Turn", keywords: ["right"] },
  { key: "Over Speeding", keywords: ["peeding"] },
  { key: "Long Idling", keywords: ["dling"] },
  { key: "Too Many Events", keywords: ["too many events"] },
  { key: "Accident Detected", keywords: ["accident"] },
];

const getAlarmType = (alarmName) => {
  alarmName = (alarmName || "").split("_").join(" ");
  let alarmType = null;
  for (let idx in alarmTypes) {
    for (let jdx in alarmTypes[idx].keywords) {
      if (
        (alarmName || "")
          .toLowerCase()
          .indexOf(alarmTypes[idx].keywords[jdx].toLowerCase()) !== -1
      ) {
        alarmType = alarmTypes[idx].key;
        break;
      }
    }
  }
  return alarmType;
};

if (window.isWhiteLabelAvailable("nh100")) {
  $("#favicon").attr("href", nh100Logo);
  $("#title").text("NH100 EYE - GPS Vehicle Tracking, TRACK.SECURE");
} else if (window.isWhiteLabelAvailable("iocl")) {
  $("#favicon").attr("href", ioclLogo);
  $("#title").text("IOCL - CVTMS");
} else if (window.isWhiteLabelAvailable("hpe")) {
  $("#favicon").attr("href", hpeLogo);
  $("#title").text("HPE");
} else if (window.isWhiteLabelAvailable("fly")) {
  $("#favicon").attr("href", flyyLogo);
  $("#title").text("FLYY - TRACK");
} else if (window.isWhiteLabelAvailable("revv")) {
  $("#favicon").attr("href", revvLogo);
  $("#title").text("REVV - TRACK");
} else if (window.isWhiteLabelAvailable("fre8wise")) {
  $("#favicon").attr("href", fre8wiseLogo);
  $("#title").text("FRE8WISE - TRACK");
} else if (window.isWhiteLabelAvailable("greendrivemobility")) {
  $("#favicon").attr("href", greenDrive);
  $("#title").text("GREEN DRIVE - TRACK");
} else if (window.isWhiteLabelAvailable("bilitielectric")) {
  $("#favicon").attr("href", Biliti_Primary_Logo);
  $("#title").text("BILITI ELECTRIC - TRACK");
} else if (window.isWhiteLabelAvailable("mondays")) {
  $("#favicon").attr("href", mondayLogo);
  $("#title").text("MONDAYS - TRACK");
} else if (window.isWhiteLabelAvailable("etomotors")) {
  $("#favicon").attr("href", ketoLogo);
  $("#title").text("ETO - TRACK");
} else if (window.isWhiteLabelAvailable("gofuel")) {
  $("#favicon").attr("href", gozapLogo);
  $("#title").text("GOZAP");
}
else if (window.isWhiteLabelAvailable("jupiterelectricmobility")) {
  $("#favicon").attr("href", jupiterLogo);
  $("#title").text("JUPITER ELECTRIC MOBILITY - TRACK");
}else if (window.isWhiteLabelAvailable("libtracx")) {
  $("#favicon").attr("href", cruzex);
  $("#title").text("Libtracx");
}

const App = (props) => {
  React.useEffect(() => {
    const processAlarmRTData = (msg) => {
      return {
        alarmName: msg.al,
        alarmType: getAlarmType(msg.al),
        lat: msg.lt,
        lng: msg.ln,
        vehicleid: msg.vp,
        time: msg.uts,
        vehicleno:
          ((props.store.getState().vehicleMap || {})[msg.vp] || {}).vehicleno ||
          "Not Available",
        date: moment(msg.uts).format(dateFormat),
      };
    };

    window.alarmRTData = [];
    window.alarmRTListeners = {};
    window.alarmRTSub = (key, listener) => {
      if (key != null && listener) {
        window.alarmRTListeners[key] = listener;
        if (window.alarmRTData && window.alarmRTData.length) {
          listener([...window.alarmRTData]);
        }
      }
    };
    window.alarmRT = (msg) => {
      let data = processAlarmRTData(msg);
      if (!data.alarmType) return;
      window.alarmRTData.push(data);
      for (let idx in window.alarmRTListeners) {
        window.alarmRTListeners[idx]([data]);
      }
    };
  }, []);

  return (
    <div className="App">
      <MainLayout />
    </div>
  );
};

export default App;
